/**
 * Guard global anti-închidere-accidentală pentru modalele cu backdrop
 * (`.v-modal-backdrop` cu onClick={close} — pattern folosit în 30+ locuri).
 *
 * Bug-ul (raportat 2026-06-12, modalul «Editează plata»): selectezi text
 * într-un input din modal și eliberezi mouse-ul în AFARA modalului → browserul
 * declanșează `click` pe strămoșul comun al lui mousedown/mouseup — adică
 * exact backdrop-ul → modalul se închide și pierzi editarea.
 *
 * Fix-ul, într-un singur loc pentru toate modalele: închiderea pe backdrop e
 * permisă DOAR dacă și mousedown-ul a început tot pe backdrop. Listener-ul de
 * `click` rulează în faza de CAPTURE pe document — înaintea handler-elor
 * React (atașate pe root) — și oprește propagarea când click-ul pe backdrop
 * provine dintr-un drag început în interiorul modalului.
 *
 * Comportament neatins: click curat pe backdrop închide ca până acum;
 * butoanele X/Anulează au target-ul lor (nu backdrop-ul) și nu trec pe aici.
 */

const BACKDROP_CLASS = 'v-modal-backdrop';

let installed = false;

function isBackdrop(t: EventTarget | null): t is HTMLElement {
  return !!t && t instanceof HTMLElement && t.classList.contains(BACKDROP_CLASS);
}

export function installModalBackdropGuard(): void {
  if (installed || typeof document === 'undefined') return;
  installed = true;

  let mouseDownOnBackdrop: HTMLElement | null = null;

  document.addEventListener(
    'mousedown',
    (e) => {
      mouseDownOnBackdrop = isBackdrop(e.target) ? e.target : null;
    },
    true,
  );

  document.addEventListener(
    'click',
    (e) => {
      if (isBackdrop(e.target) && mouseDownOnBackdrop !== e.target) {
        // Drag început în modal, terminat pe backdrop → NU e intenție de
        // închidere. Oprim evenimentul înainte să ajungă la onClick-ul React.
        e.stopPropagation();
        e.preventDefault();
      }
    },
    true,
  );
}
